import React, { Component, useState, useMemo } from "react";
import DefaultDataGrid from '../components/DefaultDataGrid';
import { DataGrid, GridToolbar, plPL, getGridStringOperators, GridActionsCellItem } from '@mui/x-data-grid';
import { useParams } from 'react-router';
import { TextField, Typography, Slide, Button, Box, CircularProgress, Grid, Checkbox, Divider } from '@mui/material';
import { Stack } from '@mui/system';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import { query, flattenObj, unflattenObject } from '../App';
import InputColumn from '../components/InputColumn'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Link } from "react-router-dom"
import RowAddPage from '../components/RowAddPage';
import RowEditPage from '../components/RowEditPage';
import InputRow from '../components/InputRow';

const filterOperators = getGridStringOperators().filter(({ value }) =>
    ['equals', 'contains', 'startsWith', 'endsWith' /* add more over time */].includes(value),
);

const columns = [
    { field: 'id', headerName: 'Id', filterOperators },
    { field: 'username', headerName: 'Login', minWidth: 150, flex: 1, filterOperators },
    { field: 'password', headerName: 'Hasło', minWidth: 150, flex: 1, filterOperators },
    { field: 'fullname', headerName: 'Imie Nazwisko', minWidth: 150, flex: 1, filterOperators },
    { field: 'permissions.admin', headerName: "Admin", type: 'boolean', width: 120 }
]
const permissionsArray = [
    { name: "Zamowienia", value: "orders" },
    { name: "Archiwum", value: "archive" },
    { name: "Produkcja", value: "production" },
    { name: "Pliki", value: "files" },
    { name: "Magazyn", value: "warehouse" },
    { name: "Kalkulacje", value: "calculations" },
    { name: "Handlowcy", value: "traders" },
    { name: "Klienci", value: "clients" },
    { name: "Uzytkownicy", value: "users" },
]
const inputColumns = {
    "Dane": [
        { type: TextField, props: { label: "Login", name: "username" } },
        { type: TextField, props: { label: "Hasło", name: "password" } },
        { type: TextField, props: { label: "Imie Nazwisko", name: "fullname" } }
    ]
}
export default function Users(props) {
    const { lookupId } = useParams();
    const [data, setData] = useState({});
    console.log(data)
    if (lookupId) return <RowEditPage title={`${(props.disableEdit ? ' Pogląd ' : 'Edycja')} uzytkownika o id: ${lookupId} `}
        queryPath='/users'
        lookupId={lookupId}
        disableInputs={props.disableEdit}
        dataReference={setData} >
        <Grid xs={12} container item>
            <InputRow inputColumns={inputColumns} data={data} disabled={props.disableEdit} />
        </Grid>
        <Grid xs={12} item className="container">
            <Typography variant="h6" textAlign="left" sx={{ marginBottom: "20px" }}>
                Uprawnienia
            </Typography>
            <Box sx={{
                display: "flex",
                overflowY: "scroll",
                width: "100%",
                height: "200px",
                overflowY: "hidden"
            }}>
                {
                    permissionsArray.map(
                        (permission, index) =>
                            <Box sx={{ width: "200px" }}>
                                <InputColumn key={"permission." + permission.name} title={permission.name} fields={
                                    [
                                        { type: Checkbox, props: { label: "Odczyt", name: `permissions.${permission.value}.read` } },
                                        { type: Checkbox, props: { label: "Edycja", name: `permissions.${permission.value}.edit` } },
                                    ]
                                } data={data} sx={{ width: "200px" }} disabled={props.disableEdit} />
                            </Box >)
                }
            </Box>
        </Grid>
    </RowEditPage >;
    else if (props.add) return <RowAddPage queryPath='/users' title="Dodawanie uzytkownika">
        <InputRow inputColumns={inputColumns} data={{}} />
    </RowAddPage>
    else return <DefaultDataGrid
        columns={columns}
        queryPath='/users'
    />;
}